(() => {
  const template = document.getElementById('kf-notify-design');
  const css = template?.content.querySelector('style')?.textContent;
  if (!css) return;

  const language = document.documentElement.lang.split('-')[0];
  const copy = {
    de: {
      title: 'Lass dich benachrichtigen',
      description: 'Trage deine E-Mail-Adresse ein. Wir benachrichtigen dich, wenn deine Größe verfügbar ist.',
      submit: 'Lass dich benachrichtigen'
    },
    en: {
      title: 'Get notified',
      description: 'Enter your email address. We’ll let you know if your size becomes available.',
      submit: 'Get notified'
    }
  }[language];
  const sizeLabel = {
    de: 'Größe auswählen', en: 'Choose size',
    fr: 'Choisir une taille', nl: 'Kies je maat'
  }[language] || 'Choose size';
  const frames = new WeakSet();
  const documents = new WeakSet();

  function selectedVariantId(purchase) {
    const form = purchase?.form || document.querySelector('button[name="add"][type="submit"]')?.form;
    return Number(form?.querySelector('[name="id"]')?.value || new URL(window.location.href).searchParams.get('variant'));
  }

  function openNotification(purchase) {
    const variantId = selectedVariantId(purchase);
    const dialog = document.getElementById('kf-notify-dialog');
    if (dialog?.kfOpen?.(variantId)) return true;
    if (!window.BIS?.popup?.show) return false;
    window.BIS.popup.show(variantId ? {variantId} : undefined);
    return true;
  }

  // The app's default text-link handler reopens the last selected size. Use the
  // current product form for every entry point, including dynamically added links.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[id="BIS_trigger"]');
    if (!trigger || !window.BIS?.popup?.show) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openNotification(trigger.closest('form')?.querySelector('button[name="add"]'));
  }, true);

  // A sold-out purchase button cannot receive clicks. Give its notification
  // label a real, non-submitting action while keeping the purchase logic intact.
  if (copy) document.querySelectorAll('button[name="add"][type="submit"]').forEach((purchase) => {
    const notify = document.createElement('button');
    notify.type = 'button';
    notify.className = 'btn btn--large kf-notify-open';
    notify.style.width = '100%';
    notify.textContent = copy.title;
    notify.hidden = true;
    purchase.insertAdjacentElement('afterend', notify);
    notify.addEventListener('click', () => {
      if (!openNotification(purchase)) document.getElementById('BIS_trigger')?.click();
    });
    const sync = () => {
      const soldOut = purchase.disabled && purchase.textContent.trim().toLowerCase() === copy.title.toLowerCase();
      purchase.hidden = soldOut;
      notify.hidden = !soldOut;
    };
    sync();
    new MutationObserver(sync).observe(purchase, {
      attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true
    });
  });

  function styleFrame(frame) {
    // AMP renders its form in an about:blank iframe. Leave the app functional
    // if a future version moves it to a different origin.
    let doc;
    try { doc = frame.contentDocument; } catch (_) { return; }
    if (!doc?.documentElement) return;

    function apply() {
      if (doc.head && !doc.getElementById('kf-notify-style')) {
        const style = doc.createElement('style');
        style.id = 'kf-notify-style';
        style.textContent = css;
        doc.head.appendChild(style);
      }
      const variants = doc.getElementById('variants');
      if (variants) {
        if (!doc.getElementById('kf-notify-size-label')) {
          const label = doc.createElement('label');
          label.id = 'kf-notify-size-label';
          label.htmlFor = variants.id;
          label.textContent = sizeLabel;
          variants.insertAdjacentElement('beforebegin', label);
        }
        variants.setAttribute('aria-label', sizeLabel);
        // This is a native dropdown, not an always-expanded listbox.
        variants.removeAttribute('role');
      }
      if (!copy) return;
      const setText = (selector, text) => {
        const element = doc.querySelector(selector);
        if (element && element.textContent !== text) element.textContent = text;
      };
      setText('#bis-modal-title', copy.title);
      setText('#bis-modal-desc', copy.description);
      // Keep the app's progress and success messages intact during submission.
      const submit = doc.querySelector('#submit-btn');
      if (submit && !submit.dataset.kfLabel) {
        submit.textContent = copy.submit;
        submit.dataset.kfLabel = 'true';
      }
    }
    apply();
    if (!documents.has(doc)) {
      documents.add(doc);
      new MutationObserver(apply).observe(doc.documentElement, {childList: true, subtree: true});
    }
  }

  function findFrame() {
    const frame = document.getElementById('BIS_frame');
    if (!frame || frames.has(frame)) return;
    frames.add(frame);
    frame.addEventListener('load', () => styleFrame(frame));
    styleFrame(frame);
  }
  findFrame();
  new MutationObserver(findFrame).observe(document.body, {childList: true});

  // Collection notification links intentionally open the form on arrival.
  if (window.location.hash === '#BIS_trigger') {
    let attempts = 0;
    const formIsOpen = () => {
      const frame = document.getElementById('BIS_frame');
      return document.getElementById('kf-notify-dialog')?.open || (frame && frame.getBoundingClientRect().height > 0);
    };
    function openFromCollection() {
      if (formIsOpen()) return;
      const trigger = document.getElementById('BIS_trigger');
      if (trigger) {
        try { trigger.click(); } catch (_) { /* The app may still be loading. */ }
      }
      if (!formIsOpen() && ++attempts < 30) {
        window.setTimeout(openFromCollection, 500);
      }
    }
    window.setTimeout(openFromCollection, 500);
  }
})();
